import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const useStyles = makeStyles((theme) => ({
  root: {},
  filterBtnGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 6,
    padding: "6px",
  },
  tooltip: {
    backgroundColor: "black !important",
  },
  activeFilterBtn: {
    background: "#0F56CA !important",
    border: "1px solid #0F56CA !important",
    color: "white !important",
  },
  table: {
    borderTop: "1px solid #CCCCCC",
  },
  badge: {
    borderRadius: "22px",
    width: "32px",
    height: "22px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  successBadge: {
    backgroundColor: "#E9FBEF",
    border: "1px solid #87E8AD",
    color: "#414651",
  },
  warningBadge: {
    border: "1px solid #daa520",
    background: "#fff4d9",
    color: "#daa520",
  },
  dangerBadge: {
    color: "#B42419",
    border: "1px solid #FDA19B",
    background: "#FEF3F2",
  },
  defaultBadge: {
    color: "#414651",
    border: "1px solid #181D1F26",
    background: "#FFFFFF",
  },
}));

export const ValueBox = styled(Box)({
  display: "flex",
  alignItems: "baseline",
});
